import { render, staticRenderFns } from "./billOfParcels.vue?vue&type=template&id=1ececcea&scoped=true&"
import script from "./billOfParcels.vue?vue&type=script&lang=js&"
export * from "./billOfParcels.vue?vue&type=script&lang=js&"
import style0 from "./billOfParcels.vue?vue&type=style&index=0&id=1ececcea&prod&lang=scss&"
import style1 from "./billOfParcels.vue?vue&type=style&index=1&id=1ececcea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ececcea",
  null
  
)

export default component.exports